import { useConfigsContext } from '@/context/ConfigsContext'
import { fetchUploadRoomImage } from '@/services/cms'
import { useCallback } from 'react'

export function useUploadImageFromUrl() {
  const { store } = useConfigsContext()
  const htcToken = store?.credentials?.htcToken

  const uploadImageFromUrl = useCallback(
    async (url: string) => {
      if (!htcToken) {
        throw new Error('missing htcToken')
      }

      const imageResponse = await fetch(url)
      const blob = await imageResponse.blob()
      const file = new File([blob], 'image.jpg', { type: blob.type })

      const response = await fetchUploadRoomImage(htcToken, file)

      if (response?.status === 200 && response?.results) {
        return response.results.url
      } else {
        throw new Error('Upload image failed')
      }
    },
    [htcToken],
  )

  return {
    uploadImageFromUrl,
  }
}
